<template>
    <img
        v-if="iconUrl"
        class="match-icon"
        :class="[{ 'match-icon--outlined': outlined, 'match-icon--transparent': !isLoaded }]"
        :src="iconUrl"
        :width="size"
        :height="size"
        :style="`--match-icon-size: ${size}px;`"
        :alt="`Ikona ${sportName}`"
        @load="isLoaded = true"
    />
</template>

<script setup lang="ts">
import { ref, computed } from "vue";

import removeAccents from "@/shared/utils/remove-accents";
import useSagOptions from "@/shared/http-clients/use-sag-options";

const props = withDefaults(
    defineProps<{
        sportName: string | undefined;
        countryName?: string;
        leagueName?: string;
        size?: string;
        outlined?: boolean;
    }>(),
    {
        size: "20",
    },
);

const isLoaded = ref(false);

const normalizeString = (string?: string) => {
    if (!string) return null;

    return removeAccents(string)
        .trim()
        .toLowerCase()
        .replaceAll(/\s+/g, "-")
        .replaceAll(/\/+/g, "-")
        .replaceAll(/\.+/g, "-");
};

const iconUrl = computed(() => {
    const sportNameNormalized = normalizeString(props.sportName);
    const countryNameNormalized = normalizeString(props.countryName);
    const leagueNameNormalized = normalizeString(props.leagueName);

    let iconName = sportNameNormalized;

    if (countryNameNormalized?.length) {
        iconName += `/${countryNameNormalized}`;

        if (leagueNameNormalized?.length) {
            iconName += `/${leagueNameNormalized}`;
        }
    }

    const iconType = props.outlined ? "outlined" : "solid";

    const { getSagApiUrl, sagSubscriptionKey } = useSagOptions();
    const apiBaseUrl = getSagApiUrl(`openbet/icon-service`);
    return `${apiBaseUrl}icon/${iconName}?format=webp&type=${iconType}&subscription-key=${sagSubscriptionKey}`;
});
</script>
